// Сортировка списка чатов (SPEC §4.8 select.chatList): pinned↑, затем по lastMessage.createdAt↓
// (при равенстве — по chat.createdAt↓, затем по id для детерминизма). Производит `chats.order`.
function lastActivity(state, chatId) {
    const chat = state.chats.byId[chatId];
    if (!chat)
        return 0;
    const ts = chat.lastMessage?.createdAt ?? chat.createdAt;
    const ms = Date.parse(ts);
    return Number.isNaN(ms) ? 0 : ms;
}
/** Пересобрать `chats.order` из текущих `chats.byId`. Стабильно и детерминированно. */
export function resortChats(state) {
    const ids = Object.keys(state.chats.byId);
    ids.sort((a, b) => {
        const ca = state.chats.byId[a];
        const cb = state.chats.byId[b];
        const pa = ca.myState.pinned ? 1 : 0;
        const pb = cb.myState.pinned ? 1 : 0;
        if (pa !== pb)
            return pb - pa; // pinned первыми
        const aa = lastActivity(state, a);
        const ab = lastActivity(state, b);
        if (aa !== ab)
            return ab - aa; // свежие активнее
        return a < b ? -1 : a > b ? 1 : 0; // детерминированный тай-брейк
    });
    state.chats.order = ids;
}
//# sourceMappingURL=sort.js.map